"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewUser = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("skybase-ui/skybase-core/shapes");

var _skybaseComponents = require("skybase-ui/skybase-components");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _sbModal = require("skybase-ui/skybase-components/sb-modal");

var _constants = require("../constants");

var _constants2 = require("../../constants");

var _utils = require("../../utils");

var _authProviders = require("./auth-providers");

var _usersI18n = require("../users-i18n");

var _messagesI18n = require("../../messages-i18n");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _ViewUser = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_ViewUser, _PureComponent);

  var _super = _createSuper(_ViewUser);

  function _ViewUser() {
    var _this;

    (0, _classCallCheck2.default)(this, _ViewUser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeader", function () {
      var _this$props = _this.props,
          _ = _this$props.intl.formatMessage,
          handleOnCloseModal = _this$props.handleOnCloseModal;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
        title: _(_usersI18n.messages.viewProfile),
        onCloseBtnClick: handleOnCloseModal
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFooter", function () {
      var _this$props2 = _this.props,
          handleOnCloseModal = _this$props2.handleOnCloseModal,
          _ = _this$props2.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-footer fl-container fl-justify-end"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-left"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-center"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-right"
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        onClick: handleOnCloseModal,
        className: "primary"
      }, _(_messagesI18n.messages.close))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getData", function (data) {
      return data || '-';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLabels", function () {
      var _this$props3 = _this.props,
          _ = _this$props3.intl.formatMessage,
          data = _this$props3.data;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: _(_usersI18n.messages.email),
        inline: true
      }, _this.getData(data.email)), /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: _(_usersI18n.messages.name),
        inline: true
      }, _this.getData(data.name)), /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: _(_usersI18n.messages.phone),
        inline: true
      }, _this.getData(data.phone)), /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: _(_usersI18n.messages.roles),
        inline: true
      }, _this.getData(data.roles.join(', '))), /*#__PURE__*/_react.default.createElement(_authProviders.AuthProviders, {
        providers: (data === null || data === void 0 ? void 0 : data.authenticationProviders) || []
      }));
    });
    return _this;
  }

  (0, _createClass2.default)(_ViewUser, [{
    key: "render",
    value: function render() {
      var handleOnCloseModal = this.props.handleOnCloseModal;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, {
        onClickOverlay: handleOnCloseModal,
        Header: this.renderHeader(),
        Footer: this.renderFooter(),
        width: 310,
        height: "auto",
        className: "oauth-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-message-modal-content"
      }, this.renderLabels()));
    }
  }]);
  return _ViewUser;
}(_react.PureComponent);

(0, _defineProperty2.default)(_ViewUser, "propTypes", {
  data: _propTypes.default.shape({
    id: _propTypes.default.string,
    email: _propTypes.default.string,
    name: _propTypes.default.string,
    roles: _propTypes.default.arrayOf(_propTypes.default.string)
  }).isRequired,
  handleOnCloseModal: _propTypes.default.func.isRequired,
  intl: _shapes.intlShape.isRequired
});

var mapStateToProps = function mapStateToProps(state) {
  var _getOAuthState$USERS_ = (0, _utils.getOAuthState)(state)[_constants.USERS_STATE_KEY_NAME][_constants.USER_STATE_KEYS.VIEW_USER],
      data = _getOAuthState$USERS_.data,
      userState = _getOAuthState$USERS_.state;

  return {
    data: data,
    loading: userState === _constants2.STATES.LOADING
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleOnCloseModal: function handleOnCloseModal() {
      return dispatch((0, _actions.closeModal)());
    }
  };
};

var ViewUser = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ViewUser));
exports.ViewUser = ViewUser;
//# sourceMappingURL=view-user.js.map